import CryptoJS from 'crypto-js'; // npm: https://www.npmjs.com/package/crypto-js doc: https://cryptojs.gitbook.io/docs/
import Vue from 'vue';
export class Encrypt {
    constructor() {
        // this.secret = 'Sx%CqfZVZz5qn$ER8ht*nsfe_kj_tAdJqxX?z&&A4@v9=$5nE-XP9XkjM5DWZ6L%' + ConfigManager.getAppId();
        var clientId = (Vue.bzbsConfig && Vue.bzbsConfig.client_id) ? Vue.bzbsConfig.client_id : 'default';
        this.secret = 'NszdXfCxU%!MynLuJd$z@(mqvT#a(J+uA$c(' + clientId;
    }

    encrypt(text) {
        let data = CryptoJS.AES.encrypt(text, this.secret);
        return data.toString();
    }

    decrypt(encrypted) {
        try {
            let data = CryptoJS.AES.decrypt(encrypted, this.secret);
            return data.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.log(e)
            return null
        }
    }
}
